import { createSlice } from "@reduxjs/toolkit";
import GnlParametreDTO from "src/models/GnlParametre/GnlparametreDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IParametreTanim {
    filterValue?: number;
    activeRow?: GnlParametreDTO;
    parametreId?: number;
    open?: boolean;
};

export const ParametreTanimSlice = createSlice<IParametreTanim, MapReducerPayloads<IParametreTanim, {
    setFilterValue?: number;
    setActiveRow?: GnlParametreDTO;
    setParametreId?: number;
    setOpen?: boolean;
}>>({
    name: "parametreTanim",
    initialState: {
        filterValue: 0,
        activeRow: new GnlParametreDTO(),
        parametreId: 0,
        open: false
    },
    reducers: {
        setFilterValue: (state, action) => {
            state.filterValue = action.payload
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
        setParametreId: (state, action) => {
            state.parametreId = action.payload
        },
        setOpen: (state, action) => {
            state.open = action.payload
        }
    }
});